"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dubino": {
    "ed2caa88": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "skipSearch": false
    }],
    "casello-7-o-bocca-d-adda": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "64df981e": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "skipSearch": false
    }],
    "colombaio": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "55306672": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "skipSearch": false
    }],
    "dosso": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "48f245c7": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "skipSearch": false
    }],
    "monastero": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef7b0fe3": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "skipSearch": false
    }],
    "rogola": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a08b1f5": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "skipSearch": false
    }],
    "spinida": [{
      "hkey": "c24f5c52",
      "slug": "dubino",
      "name": "Dubino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;